import { saveAs } from 'file-saver';
import React from 'react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { Button, Dialog } from '@gov-nx/ui/web';
import { DownloadListenerCore } from './DownloadListenerCore';

export const DownloadListener = () => {
	const { t } = useGlobalLocale();

	return (
		<DownloadListenerCore
			onSave={async ({ blob, fileName }) => saveAs(blob, fileName)}
			onAntivirus={({ onAccept, onDeny, fileName }) => (
				// @TODO: GovPrompt se nezobrazi pri startu, lepsi zkouset s obyc html
				// return <div>
				// 	<div>Opravdu chcete stáhnout soubor "{fileName}" ?</div>
				// 	<button onClick={onAccept}>Stáhnout</button>
				// 	<button onClick={onDeny}>Zrušit</button>
				// </div>
				<Dialog
					onClose={onDeny}
					isOpen={true}
					title={<h3>{t('antivirus.text.problem-s-antivirem')}</h3>}
					footer={
						<>
							<Button
								color="error"
								type="solid"
								size="m"
								onClick={onAccept}>
								{t('antivirus.action.stahnout')}
							</Button>
							<Button
								color="primary"
								type="base"
								size="m"
								onClick={onDeny}>
								{t('antivirus.action.zrusit')}
							</Button>
						</>
					}>
					{t('antivirus.text.opravdu-chcete-stahnout', { fileName })}
				</Dialog>
			)}
		/>
	);
};
